import { render, staticRenderFns } from "./ValidationAsterisk.vue?vue&type=template&id=53b26cd9"
import script from "./ValidationAsterisk.vue?vue&type=script&lang=ts"
export * from "./ValidationAsterisk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports